import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Host,
  Input,
  OnInit,
  Optional,
  Self,
  SkipSelf
} from '@angular/core';
import { ControlContainer, FormControl, NgControl } from '@angular/forms';
import { InputBase } from '../input-base/input-base';

@Component({
  selector: 'mbs-input-password',
  templateUrl: './input-password.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InputPasswordComponent extends InputBase<any> implements OnInit {
  public control: FormControl;

  @Input() validationWhitespace = true;
  @Input() disabledEye = false;
  /**
   * Add font-weight-bold;
   */
  @Input() public boldLabel = false;
  /**
   * Disable input with ignore FormControl warnings
   */
  @Input() public disabledSelf = false;
  /** Displaying '*' for required fields is the default behavior, but can be overridden. */
  @Input() public showRequiredMark = true;

  @Input() passwordInputType: 'password' | 'text' = 'password';

  @Input() formControlName?: string;
  @Input() autocomplete: 'on' | 'off' | 'new-password';

  constructor(
    @Optional() @Host() @SkipSelf() private controlContainer: ControlContainer,
    @Optional() @Self() ngControl: NgControl,
    protected cd: ChangeDetectorRef
  ) {
    super(ngControl, cd);
  }

  ngOnInit() {
    if (this.controlContainer) {
      if (this.formControlName) {
        this.control = this.controlContainer.control.get(this.formControlName) as FormControl;
      } else {
        console.warn('Missing formControlName directive');
      }
    } else {
      this.control = this.ngControl.control as FormControl;
    }
  }

  changeTypePassword(): void {
    this.passwordInputType = this.passwordInputType === 'password' ? 'text' : 'password';
  }
}
